import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { useModal } from "../../hooks/useModal";
import { StyledInput } from "./StyledInput";
import { useEffect, useState } from "react";
import { resetPassword } from "../../config/api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { StyledButton } from "./StyledButton";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  p: 4,
  minHeight: "300px",
  borderRadius: "6px",
};

const OtpModal = () => {
  const { isOpen, type, onClose, data } = useModal();

  const navigate = useNavigate();

  const open = isOpen && type === "otp";

  const defaultForm = {
    new_password: "",
    otp: "",
  };

  const [finalForm, setFinalForm] = useState(defaultForm);

  const onCloseHandler = () => {
    setFinalForm(defaultForm);
    onClose();
  };

  const changePasswordHandler = () => {
    resetPassword({
      email: data?.email,
      new_password: finalForm.new_password,
      otp: finalForm.otp,
    })
      .then((data) => {
        toast.success("Password changed successfully");
        toast.success("Login now");
        setFinalForm(defaultForm);
        onClose();
        navigate("/login");
      })
      .catch((error) => {
        if (error?.response?.data?.data) {
          toast.error(error?.response?.data?.data)
        }
        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        }
      });
  };

  return (
    <Modal open={open} onClose={onCloseHandler}>
      <Box sx={style}>
        <Stack
          justifyContent={"space-between"}
          direction={"column"}
          sx={{
            minHeight: "240px",
          }}
        >
          <div>
            <Typography variant="h6" component="h2" marginBottom={"20px"}>
              Change your password
            </Typography>
            <Stack rowGap={"10px"}>
              <StyledInput value={data?.email} fullWidth disabled />
              <StyledInput
                value={finalForm.otp}
                placeholder="Enter OTP"
                fullWidth
                onChange={(e) =>
                  setFinalForm({ ...finalForm, otp: e.target.value })
                }
              />
              <StyledInput
                value={finalForm.new_password}
                placeholder="Enter New Password"
                fullWidth
                disabled={!(finalForm.otp.length === 6)}
                onChange={(e) =>
                  setFinalForm({ ...finalForm, new_password: e.target.value })
                }
              />
            </Stack>
          </div>

          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={"8px"}
            marginTop={"20px"}
          >
            <StyledButton onClick={changePasswordHandler} variant="contained">
              Change Password
            </StyledButton>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default OtpModal;
